import { ESpinParametersType, ISpinParameters } from '@GFTypes/GameStoreTypes/SpinParameters';

export const SPIN_PARAMETERS_DEFAULTS: ISpinParameters = {
    type: ESpinParametersType.NORMAL,
    desiredVelocity: 3600,
    startYOffset: 0,
    startYOffsetTime: 0,
    stopYOffset: 40,
    stopYOffsetTime: 100,
    accelerationTime: 20,
    decelerateFrom: 30,
    tensionVelocityModifier: 1.5,
    quickStopVelocityModifier: 1.5,
    allowQuickStopOnTension: true,
    allowQuickStopOnFGTension: false,
    startTensionSoundOnEachReel: false,
    startTensionSoundOnEachReelFG: false,
    skipTensionPerReel: true,
    delayAfterWonTension: 0,
    delayAfterLostTension: 0,
    minimalSpinDuration: 0,
    symbolsShownAfterResponsePerReel: [1, 6, 11, 16, 21],
    tensionDurationForEachConsecutiveReel: [2000, 2000, 2000, 2000],
    afterTensionDurationForEachConsecutiveReel: [250, 500, 750],
    fullTensionDuration: 4500
};
